import { jsx as _jsx } from "preact/jsx-runtime";
function Chevron(props) {
    const { height, width } = props;
    return (_jsx("svg", { ...props, width: width ?? 14, height: height ?? 14, viewBox: "0 0 14 14", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", children: _jsx("polygon", { points: "2.55 2.05 4.53 .07 11.45 7 11.45 7 4.53 13.93 2.55 11.95 7.5 7 2.55 2.05" }) }));
}
Chevron.defaultProps = {
    fill: '#fff',
};
export default Chevron;
